import supportTypeEnum from '../supportTypeEnum'

export default function deltagerValidator(donationFor, donationTeam, donationParticipant) {
  return (
    donationFor !== supportTypeEnum.DELTAGER ||
    (donationTeam !== '' && donationParticipant !== '')
  )
}